import { createContext, useContext } from "react";

import { TimeFrameType } from "../resources/types";
import { ActivityFilterType } from "../utils/workers/activityworker/type";

export type MetricsContextType<D = any> = {
  activityConfig?: ActivityFilterType[];
  isDeployment: boolean;
  timeFrame: TimeFrameType;
  setTimeFrame: (timeFrame: TimeFrameType) => void;
  data?: D;
};

export const MetricsContext = createContext<MetricsContextType | null>(null);

const useMetricsContext = <D = any>() => {
  return useContext(MetricsContext) as MetricsContextType<D>;
};

export default useMetricsContext;
